Action = require 'app/scripts/models/action'
ModelLoader = require 'app/scripts/db/model-loader'

module.exports = class ViewWithActions
  limit: 50
  nextPage: 1
  shortLoad: false
  loading: false
  idModels: null

  loadMoreActions: ->
    if @loading then return
    @loading = true

    @waitForId @model, =>
      ModelLoader.loadMoreActionData @model.typeName.toLowerCase(), @model.id, @nextPage, @limit, @idModels, @getActionsFilter?() ? "all"
      .finally =>
        @loading = false
      .then (actions) =>
        @shortLoad = actions.length < @limit
        @renderActions()
        ++@nextPage
      .done()

  hasMoreActions: -> !@loading && !@shortLoad && @getActions().length >= @limit

  getActions: ->
    filteringModels = @getFilteringModels?() ? []
    @model.getActions(filteringModels...)
